var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse3, _ellipse4, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _rect, _g2, _g3, _ellipse5, _ellipse6, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect2, _g4, _path31, _g5, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect3, _path39, _ellipse7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1161,
    height: 1295,
    viewBox: "0 0 1161 1295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377.966 168.468C366.071 153.449 376.768 131.332 395.927 131.332L545.59 131.332L467.692 281.758L377.966 168.468Z",
    fill: "url(#paint0_linear_1319_511)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M450.445 446.218C432.368 452.565 414.949 435.241 421.197 417.129L470.005 275.648L586.803 398.344L450.445 446.218Z",
    fill: "url(#paint1_linear_1319_511)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M862.781 197.005C881.123 202.228 885.427 226.264 870.038 237.528L747.561 327.169L720.693 156.543L862.781 197.005Z",
    fill: "url(#paint2_linear_1319_511)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M634.137 9.34122C645.107 -5.57181 668.319 -1.98924 674.283 15.5374L722.768 158.038L542.933 133.325L634.137 9.34122Z",
    fill: "url(#paint3_linear_1319_511)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M745.654 471.541C745.272 490.08 724.172 500.509 709.211 489.553L586.066 399.368L748.734 322.234L745.654 471.541Z",
    fill: "url(#paint4_linear_1319_511)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M586.83 400.132L468.063 276.408L748.191 323.052L586.83 400.132Z",
    fill: "url(#paint5_linear_1319_511)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M543.265 132.147L724.765 158.397L748.128 324.965L468.456 278.703L543.265 132.147Z",
    fill: "url(#paint6_linear_1319_511)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.127,
    cy: 231.247,
    rx: 24.4385,
    ry: 30.5481,
    transform: "rotate(3.61711 559.127 231.247)",
    fill: "#081D0F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 676.966,
    cy: 250.382,
    rx: 24.4385,
    ry: 30.5481,
    transform: "rotate(3.61711 676.966 250.382)",
    fill: "#081D0F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M581.332 278.827C581.332 278.827 602.084 318.464 637.978 288.679",
    stroke: "black",
    strokeWidth: 3.14777,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M962.69 532.81L926.123 573.348L915.842 546.863L941.227 522.179L962.69 532.81Z",
    fill: "url(#paint7_linear_1319_511)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M940.533 522.568C946.896 533.923 961.688 537.729 973.571 531.07C985.454 524.411 989.929 509.807 983.565 498.452C977.202 487.097 962.41 483.29 950.527 489.95C938.644 496.609 934.169 511.213 940.533 522.568Z",
    fill: "url(#paint8_linear_1319_511)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M897.201 695.029L636.176 740.836C632.13 741.546 628.288 738.8 627.65 734.743L585.525 466.804C585.261 465.124 585.775 463.414 586.923 462.159L609.546 437.416L651.537 721.205C652.057 724.716 655.375 727.104 658.869 726.482L931.238 677.978L908.084 691.119C904.707 693.036 901.026 694.358 897.201 695.029Z",
    fill: "#411463"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M565.732 622.231L615.372 639.796L611.554 611.539L578.715 602.375L565.732 622.231Z",
    fill: "url(#paint9_linear_1319_511)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M579.478 602.375C579.478 615.45 568.879 626.05 555.804 626.05C542.728 626.05 532.129 615.45 532.129 602.375C532.129 589.3 542.728 578.7 555.804 578.7C568.879 578.7 579.478 589.3 579.478 602.375Z",
    fill: "url(#paint10_linear_1319_511)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M741.781 828.427C732.732 836.271 728.048 842.044 701.671 819.129C672.993 794.215 676.867 791.005 687.558 781.077C697.486 771.149 711.997 769.622 724.842 789.482C739.648 801.054 755.527 817.735 741.781 828.427Z",
    fill: "#411463"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M697.591 774.752C709.308 774.208 714.604 759.685 720.22 719.985L747.058 719.985C743.186 751.108 738.329 780.318 723.818 791.773L697.591 774.752Z",
    fill: "#411463"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M907.649 775.251C905.64 787.056 905.687 794.491 870.76 793.54C832.786 792.505 833.74 787.566 835.694 773.107C837.059 759.133 847.298 748.739 869.833 755.923C888.619 755.46 911.478 758.262 907.649 775.251Z",
    fill: "#411463"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M839.428 761.849C848.134 753.989 843.002 739.406 822.13 705.173L842.862 688.13C859.635 714.631 874.432 740.279 870.497 758.343L839.428 761.849Z",
    fill: "#411463"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M603.105 436.388C602.66 433.574 604.542 430.919 607.344 430.407L893.994 378.051C896.897 377.52 899.665 379.487 900.12 382.402L945.967 675.965C946.414 678.827 944.457 681.509 941.595 681.958L654.347 726.96C651.487 727.408 648.805 725.455 648.353 722.596L603.105 436.388Z",
    fill: "url(#paint11_linear_1319_511)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 729.952,
    cy: 539.917,
    rx: 21.8765,
    ry: 26.512,
    transform: "rotate(-15.8436 729.952 539.917)",
    fill: "#081D0F"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 823.187,
    cy: 525.242,
    rx: 21.9814,
    ry: 27.1039,
    transform: "rotate(-15.8436 823.187 525.242)",
    fill: "#081D0F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M757.512 583.049C757.512 583.049 787.33 613.151 808.266 574.47",
    stroke: "black",
    strokeWidth: 3.14777,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M972.305 620.269L917.035 275.895C920.608 271.899 923.229 271.255 929.254 273.604L986.532 618.797C981.669 623.574 978.7 624.786 972.305 620.269Z",
    fill: "#2D3F42"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.27 247.254L928.181 282.435L946.237 404.576L1160.84 374.028L1152.05 310.641L1143.27 247.254Z",
    fill: "url(#paint12_linear_1319_511)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M359.444 759.088L279.916 708.493C208.26 808.62 138.829 825.604 24.6134 868.774L135.963 999.109C244.113 956.595 292.311 902.242 359.444 759.088Z",
    fill: "url(#paint13_linear_1319_511)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8415 914.597C158.009 859.489 212.408 839.08 296.367 723.017L335.4 747.875C275.271 852.215 229.891 902.356 112.931 971.796L63.8415 914.597Z",
    fill: "url(#paint14_linear_1319_511)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1319_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.904 345.34C566.883 344.675 569.021 345.853 569.466 347.847C584.861 416.683 583.305 449.159 578.316 499.544C578.072 502.011 575.345 503.463 573.126 502.309L414.923 420.006C412.566 418.78 412.439 415.509 414.701 414.073C458.513 386.243 498.716 367.572 564.904 345.34Z",
    fill: "#23583E"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M519.226 677.449C521.247 675.938 524.153 677.033 524.678 679.502C538.212 743.104 533.457 780.424 511.738 843.614C511.117 845.419 509.149 846.408 507.341 845.8C472.243 834.002 453.725 823.27 427.953 796.735C426.959 795.712 426.696 794.157 427.287 792.857C451.279 740.101 471.331 713.27 519.226 677.449Z",
    fill: "#23583E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M285.714 543.329C286.07 541.069 284.024 539.09 281.674 539.439C212.657 549.709 183.501 582.916 133.432 629.474C132.067 630.744 131.987 632.862 133.276 634.229C162.797 665.55 177.183 665.353 216.168 681.511C217.616 682.111 219.328 681.738 220.333 680.587C259.152 636.16 275.77 606.546 285.714 543.329Z",
    fill: "#23583E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 132.813,
    height: 37.2498,
    rx: 3.14777,
    transform: "matrix(0.871595 0.490227 -0.509762 0.860315 277.023 680.153)",
    fill: "#35674B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1319_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.991 399.338L580.782 478.662C568.114 623.669 533.353 686.21 457.971 788.684L217.589 656.014C269.317 539.76 307.991 479.092 437.991 399.338Z",
    fill: "#388861"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1319_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.916 433.792C493.942 431.689 498.811 434.255 499.197 438.683L526.288 749.547C526.723 754.538 521.259 758.024 516.807 755.596L212.393 589.547C208.013 587.158 208.126 580.938 212.591 578.607L489.916 433.792Z",
    fill: "url(#paint15_linear_1319_511)"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2428,
    cy: 21.9442,
    rx: 18.2428,
    ry: 21.9442,
    transform: "matrix(0.915325 0.402716 -0.416511 0.909131 357.277 538.245)",
    fill: "#081D0F"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2428,
    cy: 21.9442,
    rx: 18.2428,
    ry: 21.9442,
    transform: "matrix(0.915325 0.402716 -0.416511 0.909131 434.965 581.578)",
    fill: "#081D0F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M369.832 602.067C369.832 602.067 377.879 637.238 407.011 623.337",
    stroke: "black",
    strokeWidth: 3.14777,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M491.295 1142.11C490.007 1201.18 520.366 1202.93 608.262 1178.04C696.158 1153.14 571.249 1010.9 430.061 971.82C436.189 1004.56 437.942 1022.55 464.919 1059.7C483.63 1088.25 491.157 1105.54 491.295 1142.11Z",
    fill: "#0842A1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M481.673 1165.62L547.318 1088.66L565.454 1065.87L511.769 1020.37L474.353 1072L435.309 1122.75L481.673 1165.62Z",
    fill: "#596CB8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M433.682 1124.5C417.414 1163.87 445.883 1192.75 481.673 1165.62L504.449 1139.37L455.644 1095.62L433.682 1124.5Z",
    fill: "#325EC1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M731.283 1033.65C749.903 1031.2 764.054 1025.56 795.434 1008.45L772.523 965.678C742.427 975.372 728.398 976.822 709.899 970.26L697.68 984.007C715.896 1002.12 723.28 1012.98 731.283 1033.65Z",
    fill: "#7B96FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M712.681 1051.9C710.901 1050.92 708.665 1051.49 707.576 1053.21L677.457 1100.68C676.302 1102.5 676.869 1104.91 678.714 1106.03L738.315 1142.09L800.002 1183C801.798 1184.19 804.222 1183.67 805.377 1181.85L835.497 1134.38C836.586 1132.67 836.151 1130.4 834.504 1129.21L775.448 1086.46L712.681 1051.9Z",
    fill: "#667DD4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M839.351 1108.98C838.538 1108.93 837.734 1109.24 837.173 1109.83C827.236 1120.29 822.225 1127.4 815.1 1140.76C814.814 1141.29 814.362 1141.72 813.814 1141.98L773.734 1160.82C771.73 1161.76 771.562 1164.54 773.439 1165.72L824.098 1197.45C825.268 1198.18 826.804 1197.95 827.705 1196.9C850.12 1170.89 860.551 1156.59 873.866 1133.96C874.385 1133.08 874.38 1131.98 873.85 1131.1C864.296 1115.36 859.079 1110.24 839.351 1108.98Z",
    fill: "#325EC1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 65.5234,
    height: 30.5481,
    transform: "matrix(-0.538904 0.842367 0.842367 0.538904 810.582 1111.8)",
    fill: "#325EC1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1319_511)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.774,
    cy: 112.264,
    rx: 126.774,
    ry: 112.264,
    transform: "matrix(-1 0 0 1 770.672 968.316)",
    fill: "url(#paint16_linear_1319_511)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M670.344 1099.81L646.942 1009.24L637.616 1011.62L667.236 1114.93L670.344 1099.81Z",
    fill: "url(#paint17_linear_1319_511)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1319_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.121 854.139C361.065 926.691 416.051 1042.9 546.646 1032.08C669.106 1021.94 775.114 969.458 768.883 845.739C763.537 739.584 654.328 651.758 567.266 658.632C455.916 658.632 368.846 741.975 364.121 854.139Z",
    fill: "white"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M409.263 878.69C406.843 931.652 442.572 1010.14 545.965 1002.24C642.918 994.839 740.296 940.582 735.363 850.268C731.131 772.776 665.866 715.856 583.379 723.011C485.633 723.011 413.003 796.811 409.263 878.69Z",
    fill: "#09132C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M426.244 874.273C426.244 939.227 490.249 993.228 544.618 985.01C675.975 965.154 718.742 922.426 718.742 857.472C718.742 792.518 664.519 732.225 578.221 739.862C500.613 739.862 426.244 809.319 426.244 874.273Z",
    fill: "url(#paint18_linear_1319_511)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M654.766 832.378C655.025 848.88 655.88 858.568 635.234 869.326C633.666 870.144 631.968 870.727 630.226 871.028C612.213 874.148 602.816 868.789 592.142 852.234",
    stroke: "black",
    strokeWidth: 3.49752,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M543.672 865.181C543.931 881.683 544.787 891.371 524.141 902.129C522.572 902.946 520.874 903.529 519.132 903.831C501.119 906.951 491.722 901.592 481.048 885.037",
    stroke: "black",
    strokeWidth: 3.49752,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M609.77 913.19C609.77 913.19 584.357 936.356 558.98 928.71",
    stroke: "black",
    strokeWidth: 3.14777,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M612.107 1117.55C610.655 1116.13 608.348 1116.08 606.839 1117.44L565.088 1155.08C563.486 1156.53 563.384 1159.01 564.862 1160.58L612.603 1211.31L661.051 1267.27C662.461 1268.9 664.935 1269.05 666.536 1267.61L708.287 1229.96C709.798 1228.6 709.987 1226.3 708.72 1224.71L663.298 1167.69L612.107 1117.55Z",
    fill: "url(#paint19_linear_1319_511)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M718.818 1206.52C718.049 1206.26 717.19 1206.34 716.491 1206.76C704.113 1214.17 697.379 1219.67 686.93 1230.63C686.512 1231.06 685.96 1231.36 685.363 1231.46L641.699 1238.85C639.516 1239.22 638.607 1241.86 640.099 1243.5L680.386 1287.66C681.316 1288.68 682.86 1288.86 684.008 1288.1C712.58 1269.05 726.467 1258.07 745.365 1239.85C746.101 1239.14 746.393 1238.07 746.116 1237.09C741.137 1219.36 737.485 1213.03 718.818 1206.52Z",
    fill: "#325EC1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 65.5234,
    height: 30.5481,
    transform: "matrix(-0.745167 0.666878 0.666878 0.745167 690.352 1201.52)",
    fill: "#325EC1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M843.545 966.442C848.127 951.168 842.781 927.493 809.942 928.257C789.02 931.689 788.201 941.168 787.795 958.805L772.964 966.442L795.432 1008.45C795.432 1008.45 840.205 979.748 843.545 966.442Z",
    fill: "#325EC1"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.8159,
    cy: 18.698,
    rx: 33.8159,
    ry: 18.698,
    transform: "matrix(-0.847997 -0.530002 -0.530002 0.847997 676.414 776.863)",
    fill: "#90BDF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1319_511",
    x: 386.847,
    y: 345.153,
    width: 221.174,
    height: 288.715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 104.926
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.1157
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1319_511",
    x: 207.797,
    y: 399.339,
    width: 373.684,
    height: 404.734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.54678,
    dy: 10.1428
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.62314
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1319_511",
    x: 199.379,
    y: 430.598,
    width: 336.727,
    height: 342.927,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.3448
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.89653
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1319_511",
    x: 508.377,
    y: 962.021,
    width: 267.541,
    height: 238.518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.74876,
    dy: 0.699505
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.49752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1319_511",
    x: 354.557,
    y: 654.756,
    width: 422.632,
    height: 392.021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.699505,
    dy: 5.24629
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.37191
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_511"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_511",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1319_511",
    x1: 540.987,
    y1: 247.439,
    x2: 719.693,
    y2: 469.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1319_511",
    x1: 540.987,
    y1: 247.439,
    x2: 719.693,
    y2: 469.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1319_511",
    x1: 540.987,
    y1: 247.439,
    x2: 719.693,
    y2: 469.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1319_511",
    x1: 540.987,
    y1: 247.439,
    x2: 719.693,
    y2: 469.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1319_511",
    x1: 540.987,
    y1: 247.439,
    x2: 719.693,
    y2: 469.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1319_511",
    x1: 540.987,
    y1: 247.439,
    x2: 719.693,
    y2: 469.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1319_511",
    x1: 540.987,
    y1: 247.439,
    x2: 719.693,
    y2: 469.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF930F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1319_511",
    x1: 973.552,
    y1: 493.605,
    x2: 916.733,
    y2: 568.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1319_511",
    x1: 973.552,
    y1: 493.605,
    x2: 916.733,
    y2: 568.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1319_511",
    x1: 538.239,
    y1: 593.211,
    x2: 622.246,
    y2: 628.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1319_511",
    x1: 538.239,
    y1: 593.211,
    x2: 622.246,
    y2: 628.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#411463"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1319_511",
    x1: 607.211,
    y1: 432.202,
    x2: 946.923,
    y2: 676.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A23CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF342B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1319_511",
    x1: 950.02,
    y1: 303.619,
    x2: 1139.42,
    y2: 431.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6A670"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1319_511",
    x1: 314.389,
    y1: 738.802,
    x2: 104.711,
    y2: 941.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#BAFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149038,
    stopColor: "#80EDE5",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812079,
    stopColor: "#121831",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1319_511",
    x1: 309.634,
    y1: 733.645,
    x2: 72.8,
    y2: 962.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAFFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#80EDE5",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677885,
    stopColor: "#0C101F",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1319_511",
    x1: 493.681,
    y1: 424.074,
    x2: 357.985,
    y2: 695.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6F780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218F8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1319_511",
    x1: 47.1214,
    y1: -0.00000592273,
    x2: 182.574,
    y2: 237.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A5A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1319_511",
    x1: 645.54,
    y1: 1009.5,
    x2: 664.875,
    y2: 1115.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6079D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405BC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1319_511",
    x1: 617.604,
    y1: 739.206,
    x2: 534.044,
    y2: 997.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7088E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1319_511",
    x1: 587.58,
    y1: 1134.8,
    x2: 689.032,
    y2: 1247.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5264AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.240385,
    stopColor: "#5669B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.67c421f67f1b26d2a3358dbde5d5a9c3.svg";
export { ForwardRef as ReactComponent };